import axios from 'axios';
import { message } from "antd";
import {CANCEL} from "redux-saga";
import {Cookies} from "react-cookie";
import {COOKIE_KEY, LANG_KEY} from "../constants";
import {getFromUrl} from "./getFromUrl";
import dayjs from "dayjs";
import {removeTokenCookie} from "../hooks/useAuth";
import i18n from "./i18n";

const cookies = new Cookies()

const cancelTokenSource = axios.CancelToken.source();

let promiseNew = axios.create({
  baseURL: process.env.REACT_APP_URL,
  headers: {
    accept: 'application/json, text/plain, */*',
  },
  cancelToken: cancelTokenSource.token,
  params: {
    // debug: process.env.REACT_APP_ENV === 'production' ? null : true
  }
})

let promiseOld = axios.create({
  baseURL: process.env.REACT_APP_URL_OLD,
  headers: {
    accept: 'application/json',
    "access-key":  `${dayjs().format('DD.MM.YYYY')}-college`,
    "Accept-Language": `${i18n.language}`
  },
  cancelToken: cancelTokenSource.token,
  params: {
    // debug: process.env.REACT_APP_ENV === 'production' ? null : true
  }
})

let promiseOldRest = axios.create({
  baseURL: process.env.REACT_APP_URL_OLD_REST,
  headers: {
    accept: 'application/json',
    "access-key":  `${dayjs().format('DD.MM.YYYY')}-college`
  },
  cancelToken: cancelTokenSource.token,
  params: {
    // debug: process.env.REACT_APP_ENV === 'production' ? null : true
  }
})

//@ts-ignore
promiseNew[CANCEL] = () => cancelTokenSource.cancel();
// @ts-ignore
promiseOld[CANCEL] = () => cancelTokenSource.cancel();
// @ts-ignore
promiseOldRest[CANCEL] = () => cancelTokenSource.cancel();

const axiosConfigNew = promiseNew
const axiosConfigOld = promiseOld
const axiosConfigOldRest = promiseOldRest


axiosConfigNew.interceptors.request.use(
  async (config) => {
    let token = cookies.get(COOKIE_KEY.ACCESS_TOKEN)
    let lang = cookies.get(COOKIE_KEY.LANG) || (getFromUrl(COOKIE_KEY.LANG_OLD) ?? getFromUrl(COOKIE_KEY.LANG)) || LANG_KEY.RU

    if(token){
      config.headers["Authorization"] = `Bearer ${token}`
      config.headers["Accept-Language"] = lang;
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
axiosConfigOld.interceptors.request.use(
  async (config) => {
    let token = cookies.get(COOKIE_KEY.ACCESS_TOKEN)
    let lang = cookies.get(COOKIE_KEY.LANG) || (getFromUrl(COOKIE_KEY.LANG_OLD) ?? getFromUrl(COOKIE_KEY.LANG)) || LANG_KEY.RU

    if(token){
      config.headers["jwt"] = `${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
axiosConfigOldRest.interceptors.request.use(
  async (config) => {
    let token = cookies.get(COOKIE_KEY.ACCESS_TOKEN)
    let lang = cookies.get(COOKIE_KEY.LANG) || (getFromUrl(COOKIE_KEY.LANG_OLD) ?? getFromUrl(COOKIE_KEY.LANG)) || LANG_KEY.RU

      config.headers["Accept-Language"] = lang
    if(token){
      config.headers["jwt"] = `${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

axiosConfigNew.interceptors.response.use(
  async (config) => {
    return config
  },
  error => {
    if(error.response.data.message){
      message.error(error.response.data.message)
    }

    if(error.response.status == '401'){
      removeTokenCookie()
    }

    return Promise.reject(error)
  }
)
axiosConfigOld.interceptors.response.use(
  async (config) => {
    return config
  },
  error => {
    message.error(error.response.data.message)

    if(error.response.status == '401'){
      removeTokenCookie()
    }

    return Promise.reject(error)
  }
)
axiosConfigOldRest.interceptors.response.use(
  async (config) => {
    return config
  },
  error => {
    message.error(error.response.data.message)

    if(error.response.status == '401'){
      removeTokenCookie()
    }

    return Promise.reject(error)
  }
)

export {axiosConfigNew, axiosConfigOld, axiosConfigOldRest}